import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import './App.css';
import { AdminAuthProvider } from './admin/Provider/AdminAuthProvider';
import AdminRouting from './admin/components/AdminRouting';
import { adminConfig } from './admin/config/AdminConfig';

// Admin Mode Check Component
const AdminModeCheck = ({ children }) => {
  const isAdminMode = adminConfig.isAdminMode();
  
  if (!isAdminMode) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center">
        <div className="text-center text-white">
          <h1 className="text-4xl font-bold mb-4">🔒 Admin Mode Disabled</h1>
          <p className="text-gray-300 mb-8">This build is not configured for admin access.</p>
          <div className="bg-gray-800 rounded-lg p-6 max-w-md mx-auto">
            <p className="text-sm text-gray-400">
              Admin mode is controlled by environment variables.
              <br />
              Contact your system administrator for access.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return children;
};

// Main Admin App Component
function AdminApp() {
  return (
    <AdminModeCheck>
      <div className="AdminApp">
        <Router>
          <AdminAuthProvider>
            <AdminRouting />
          </AdminAuthProvider>
        </Router>
      </div>
    </AdminModeCheck>
  );
}

export default AdminApp;